import { render, staticRenderFns } from "./UploadListFooter.vue?vue&type=template&id=7587be3c&"
import script from "./UploadListFooter.vue?vue&type=script&lang=js&"
export * from "./UploadListFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports